import { createFileRoute } from '@tanstack/react-router';

import { DestinationGroupsContainer } from '@/features/destination-groups/containers';

export const Route = createFileRoute('/_layout/destination-groups/')({
  component: DestinationGroupsContainer,
});
